import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 采购申请单列表
    { key: 'getApplys', url: 'applys', method: 'GET' },
    // 创建采购申请单
    { key: 'addApplys', url: 'applys', method: 'POST' },
    // 修改采购申请单
    { key: 'putApplys', url: 'applys', method: 'PUT' },
    // 删除采购申请单
    { key: 'deleteApplys', url: 'applys', method: 'DELETE' },
    // 采购申请单明细
    { key: 'getApplysDetail', url: 'applys/detail', method: 'GET' },
    // 反审采购申请单
    { key: 'antiAuditApplys', url: 'applys/anti-audit', method: 'PATCH' },
    // 审核采购申请单
    { key: 'auditApplys', url: 'applys/audit', method: 'PATCH' },
    // 取消采购申请单
    { key: 'cancelApplys', url: 'applys/cancel', method: 'PATCH' },
    // 取消申请采购申请单
    { key: 'finishApplys', url: 'applys/finish', method: 'PATCH' },
    // 采购申请单转申请单商品列表
    {
      key: 'getToPurchaseGoods',
      url: 'applys/to-purchase-goods',
      method: 'POST',
    },
    // 采购申请单导出
    { key: 'reportApplys', url: 'applys/report', method: 'GET', rType: 2 },
    // 降本统计导出
    { key: 'costReportApplys', url: 'purchases/skuPurchaseCostReport', method: 'GET', rType: 2 },

    // 采购预测
    { key: 'spurPrediction', url: 'spurPrediction/pageList', method: 'POST' },
    // 采购预测导出
    { key: 'spurPredictionExport', url: 'spurPrediction/export', method: 'POST', rType: 2 },

    // 采购商品忽略
    { key: 'purchaseSkuIgnore', url: 'spurPrediction/purchaseSkuIgnore', method: 'POST' },
    // 解除商品忽略
    { key: 'purchaseSkuIgnoreCancel', url: 'spurPrediction/purchaseSkuIgnoreCancel', method: 'POST' },
    // 忽略审核
    { key: 'purchaseSkuIgnoreAudit', url: 'spurPrediction/purchaseSkuIgnoreAudit', method: 'POST' },

    // 采购预测供应商分组列表
    {key: 'getSupplierGroupList', url: 'spurPrediction/supplierGroupList', method: 'POST'},

    // 获取实时汇率
    { key: 'getExchangeRate', url: 'exchangeRate/getExchangeRate', method: 'GET' },

    // 创建采购配置
    { key: 'addPurchaseConfig', url: 'purchase/config', method: 'POST' },
    // 获取采购配置列表
    { key: 'getPurchaseConfig', url: 'purchase/config', method: 'GET' },
    // 修改采购配置
    { key: 'editPurchaseConfig', url: 'purchase/config', method: 'PUT' },
    // 删除采购配置
    { key: 'deletePurchaseConfig', url: 'purchase/config/batch', method: 'DELETE' },

    // 订单托盘信息分页列表
    { key: 'getOrderPalletPageList', url: 'order-pallet/pageList', method: 'POST' },
    // 创建订单托盘信息
    { key: 'saveOrderPallet', url: 'order-pallet/save', method: 'POST' },
    // 废弃订单托盘信息
    { key: 'discardOrderPallet', url: 'order-pallet/discard', method: 'GET' },
  ],
};
export default {
  ...generate(config),
};
